import React from 'react';
import { Block } from 'baseui/block';
import { CustomTheme } from '../baseweb-custom-theme/customTheme';

export interface ChatUserStampProps {
  /** Informational text shown above (e.g., "This is a translated message") */
  primaryText?: string;
  /** Action link text (e.g., "Hide Original") */
  secondaryText?: string;
}

/**
 * ChatUserStamp
 * ---------------------------------------------------------------------
 * Renders a small right-aligned informational footer for translated
 * chat messages — typically includes an info line and an actionable link.
 */
export const ChatUserStamp = ({
  primaryText = '',
  secondaryText = '',
}: ChatUserStampProps) => {
  return (
    <Block
      overrides={{
        Block: {
          style: ({ $theme }: { $theme: CustomTheme }) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            lineHeight: 1.4,
          }),
        },
      }}
    >
      {/* Info text */}
      {primaryText && (
        <Block
          overrides={{
            Block: {
              style: ({ $theme }: { $theme: CustomTheme }) => ({
                fontSize: $theme.typography.LabelSmall?.fontSize ,
                color: $theme.colors.contentPrimary,
                marginBottom: $theme.sizing.scale100,
                fontWeight: 600,
              }),
              props: { 'data-testid': 'chat-user-name' },
            },
          }}
        >
          {primaryText}
        </Block>
      )}

      {/* Action link */}
    {secondaryText && (
        <Block
          overrides={{
            Block: {
              style: ({ $theme }: { $theme: CustomTheme }) => ({
                fontSize: $theme.typography.LabelSmall?.fontSize ,
                color: $theme.colors.contentSecondary,
              }),
            },
          }}
        >
          {secondaryText}
        </Block>
      )}
    </Block>
  );
};
